import { createAction } from '@reduxjs/toolkit';
import { MENU__SET_ACTIVE } from 'store/constants';

export const setMenuStatusAction = createAction<string>(MENU__SET_ACTIVE);
